import React, { useEffect, useRef } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import ImageHeroSlice from './HeroSliceImage'
import VideoHeroSlice from './HeroSliceVideo'
import Swiper from 'swiper'

const CalendarIcon = () => (
  <svg
    className="w-5 h-5 mr-2 fill-current flex-shrink-0"
    viewBox="0 0 19.52 19.97"
  >
    <path d="M7.05,11a.45.45,0,0,0-.45-.45H5a.45.45,0,0,0-.45.45V12.6a.45.45,0,0,0,.45.45H6.6a.45.45,0,0,0,.45-.45Zm4,0a.45.45,0,0,0-.45-.45H9a.45.45,0,0,0-.45.45V12.6a.45.45,0,0,0,.45.45h1.58A.45.45,0,0,0,11,12.6Zm4,0a.46.46,0,0,0-.46-.45H12.92a.45.45,0,0,0-.45.45V12.6a.45.45,0,0,0,.45.45H14.5A.46.46,0,0,0,15,12.6ZM7.05,15a.46.46,0,0,0-.45-.46H5a.46.46,0,0,0-.45.46v1.58A.45.45,0,0,0,5,17H6.6a.45.45,0,0,0,.45-.45Zm4,0a.46.46,0,0,0-.45-.46H9a.46.46,0,0,0-.45.46v1.58A.45.45,0,0,0,9,17h1.58a.45.45,0,0,0,.45-.45Zm4,0a.47.47,0,0,0-.46-.46H12.92a.46.46,0,0,0-.45.46v1.58a.45.45,0,0,0,.45.45H14.5a.46.46,0,0,0,.46-.45ZM17.78,2.22V4.64a2,2,0,0,1-2,2H14.56a2,2,0,0,1-2-2V2.21H7V4.64a2,2,0,0,1-2,2H3.71a2,2,0,0,1-2-2V2.22A1.8,1.8,0,0,0,0,4V18.17A1.8,1.8,0,0,0,1.79,20H17.73a1.8,1.8,0,0,0,1.79-1.8V4A1.8,1.8,0,0,0,17.78,2.22Zm-.57,15.06a.78.78,0,0,1-.78.78H3.06a.78.78,0,0,1-.78-.78V10a.78.78,0,0,1,.78-.77H16.43a.78.78,0,0,1,.78.77Zm-13.5-12H4.94a.67.67,0,0,0,.68-.67v-4A.67.67,0,0,0,4.94,0H3.71A.68.68,0,0,0,3,.68v4A.68.68,0,0,0,3.71,5.31Zm10.83,0h1.24a.68.68,0,0,0,.68-.67v-4A.68.68,0,0,0,15.78,0H14.54a.67.67,0,0,0-.67.68v4A.67.67,0,0,0,14.54,5.31Z" />
  </svg>
)

const HeroSlices = ({ heroRef, heroSlices }) => {
  const data = useStaticQuery(graphql`
    query {
      prismicGlobals {
        data {
          booking_button_text
          booking_button {
            url
          }
        }
      }
    }
  `)
  const globals = data.prismicGlobals.data
  const bookingUrl =
    globals.booking_button?.url ||
    'https://book-directonline.com/properties/mipadhoteldirect'
  const bookingText = globals.booking_button_text || 'Book Now'

  const swiper = useRef(null)
  useEffect(() => {
    if (heroSlices.length > 1) {
      new Swiper(swiper.current, {
        effect: 'fade',
        speed: 1500,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: false,
        slidesPerView: 1,
        simulateTouch: false,
        pagination: {
          el: '.carousel__pagination',
          type: 'bullets',
          bulletClass: 'carousel__pagination-bullet',
          bulletActiveClass: 'carousel__pagination-bullet--active',
          clickable: true,
        },
      })
    }
    return () => {
      // ..
    }
  })

  return (
    <div className="relative mb-1" ref={heroRef}>
      <div className="hero relative hero--has-sub-heading">
        {heroSlices && (
          <div ref={swiper} className="absolute inset-0 z-10">
            <div
              className={`box-border w-full h-full ${
                heroSlices.length > 1 ? 'swiper-wrapper' : ' '
              }`}
            >
              {heroSlices.map((item, index) => (
                <React.Fragment key={index}>
                  {item.slice_type === 'video' && (
                    <VideoHeroSlice sliceData={item} />
                  )}
                  {item.slice_type === 'image' && (
                    <ImageHeroSlice sliceData={item} />
                  )}
                </React.Fragment>
              ))}
            </div>
            {heroSlices.length > 1 && (
              <div className="carousel__pagination carousel__pagination--hero"></div>
            )}
          </div>
        )}
        {/* Mobile/tablet booking call to action, overlaying the hero */}
        <div className="absolute inset-0 z-30 flex items-end justify-center pb-16 md:justify-end md:pr-10 md:pb-14 lg:pr-18 lg:pb-22 xl:hidden pointer-events-none">
          <a
            data-ga-target={'hero-book-button'}
            className="hero__book-now pointer-events-auto"
            href={bookingUrl}
          >
            <CalendarIcon />
            {bookingText}
          </a>
        </div>
      </div>
    </div>
  )
}

export default HeroSlices
